import * as stylex from '@stylexjs/stylex';
import '@astryxdesign/core/theme/tokens.stylex';
import { colorVars, fontWeightVars, spacingVars } from '@astryxdesign/core/theme/tokens.stylex';
import { QronMark } from './QronMark';
export function QronLogo({
  size = 28,
  framed = false,
  name = 'QronStat'
}: {
  size?: number;
  framed?: boolean;
  name?: string;
}) {
  const split = name.startsWith('Qron') ? 4 : name.length;
  return <span {...{
    0: {
      className: "x1n2onr6 x3nfvp2 x6s0dn4 x1txdalj x1tgivj0 x2mo6ok x16q24ku xo5v014 xuxw1ft"
    },
    1: {
      className: "x1n2onr6 x3nfvp2 x6s0dn4 x1txdalj x1tgivj0 x2mo6ok x16q24ku xo5v014 xuxw1ft xu0wf1k xf314gf"
    }
  }[!!framed << 0]} style={{
    fontSize: Math.round(size * 0.58)
  }}>
      {framed ? <>
          <span aria-hidden="true" className="x10l6tqk xci0xqf x1hagigm xqvcbtt x1y0btm7 xc342km x1ks1olk x47corl x1e0gzzx x1xf60ip x5see2y x1x3agtl" />
          <span aria-hidden="true" className="x10l6tqk xci0xqf x1hagigm xqvcbtt x1y0btm7 xc342km x1ks1olk x47corl x1e0gzzx xhu3bip x5see2y x16hg961" />
          <span aria-hidden="true" className="x10l6tqk xci0xqf x1hagigm xqvcbtt x1y0btm7 xc342km x1ks1olk x47corl x48lskh x1xf60ip x1pzews7 x1x3agtl" />
          <span aria-hidden="true" className="x10l6tqk xci0xqf x1hagigm xqvcbtt x1y0btm7 xc342km x1ks1olk x47corl x48lskh xhu3bip x1pzews7 x16hg961" />
        </> : null}
      <QronMark size={size} />
      <span>
        {name.slice(0, split)}
        <span {...{
        0: {},
        1: {
          className: "xjse4m1"
        }
      }[!!framed << 0]}>{name.slice(split)}</span>
      </span>
    </span>;
}